
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Marcel A., 85 ans, 16 novembre 2020</b>
    <br />
    <br />
    <i>Sa fille raconte:</i>
    <br />
    <p>
  «Je trouve que trop de personnes banalisent le Covid-19. Ils prétendent que
  c’est une grippette, que ce n’est pas grave pour la santé. Il faut
  malheureusement vivre de près les effets de ce virus pour se rendre compte que
  ce n’est pas vrai. Il faudrait envoyer les “coronasceptiques” aux soins
  intensifs d’un hôpital pour leur faire prendre conscience de la réalité. Avec
  mes soeurs, nous avons accompagné mon père jusqu’à son dernier souffle aux
  soins continus. Je vous assure que ce n’est pas drôle, mais horrible. Nous ne
  souhaitons à personne de vivre ce que nous avons vécu. Cette fin de vie était
  totalement inattendue pour notre famille. Avant d’être infecté, Papa était en
  pleine forme. Il vivait avec Maman chez lui. Il prenait soin d’elle, qui
  souffre d’alzheimer. C’est lui qui s’occupait de tout dans la maison: il
  faisait le ménage, la lessive, les rangements, il cuisinait. Il était
  indépendant. Jusqu’à l’arrivée du coronavirus. Début novembre, il m’a dit
  qu’il était barbouillé, fatigué et pas très en forme. Sur le moment, je m’en
  souviens très bien, nous ne nous sommes pas inquiétés. Nous avons toujours
  respecté les gestes barrières, surtout pour maman qui est fragile. Nous
  pensions être à l’abri. Et pourtant. La santé de mon père s’est dégradée du
  jour au lendemain. Les soins à domicile l’ont envoyé en urgence à l’hôpital de
  Delémont (JU) un jeudi. Il est décédé quatre jours après. Nous avons assisté à
  l’évolution des problèmes respiratoires, qui lui ont pris toute son énergie.
  La veille de sa mort, il n’arrivait plus à souffler. Il recevait la dose
  maximale d’oxygène, mais les médecins ne l’ont jamais soumis à la respiration
  artificielle, car c’était son désir. car c’était son désir. Le jeudi matin,
  l'infirmière lui a administré de la morphine pour soulager ses souffrances et
  notre papa s'est endormi. La veille son médecin nous disait que son état de
  santé s’améliorait.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;